import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class ListTeamsBadgeComponent extends Component {
  get value() {
    return this.args.value ?? undefined;
  }

  @action
  onTeamSelect(team) {
    this.args?.onSelect?.(team);
  }
}
